export default __webpack_public_path__ + "static/media/iphone-mockup.f706a51f.png";